import sybilHRT from './initial/flow';

const SybilFlows = { sybilHRT };

export default SybilFlows;
